import { Icon } from '@/ui/icon2'
import { useNewChat } from '@/features/sidebar/hooks'
import style from './index.module.css'
import cx from 'classnames'

export const NewChat = ({ isCollapsed }: { isCollapsed?: boolean }) => {
  const handleNewChat = useNewChat()

  return (
    <div className={style.container}>
      <button
        id="new-chat"
        onClick={handleNewChat}
        className={cx(style.button, { [style.collapsed]: isCollapsed })}
      >
        <Icon size={14} name="write" />
        {!isCollapsed && <span>Nuevo Chat</span>}
      </button>
    </div>
  )
}
